module.exports = __webpack_public_path__ + "img/axe.be5030ca.webp";